// import * as Styles from './home.styles';
import React from 'react';
import * as Styles from './projects.styles';

export const Projects: React.FC = () => {
    const projectList = [
      {
        title: "Nanoservices Utils",
        description: `An open source Rust crate with tens of thousands of downloads that provides utilities for 
        building servers in Rust. This package smoothes out error handling for all major web frameworks. This crate also 
        provides macros for database handles and mocking of database connections for tests. The main theory behind this 
        crate is covered in the third edition of the Packt Rust Web Programming book written by Maxwell Flitton. 
        Members can contribute to this project and receive guidance and tutoring from Maxwell Flitton on this project.`,
        link: "https://crates.io/crates/nanoservices-utils"
      },
      {
        title: "Dockpack",
        description: `This open project is a file distribution tool built on top of docker. As Docker is already 
        integrated into every continuous integration pipeline and major cloud provider, the open source Dockpack tool enables
        teams to distribute private packages using infrastructure that they are already using and paying for.`,
        link: "https://crates.io/crates/dockpack"
      },
      {
        title: "Kafkad",
        description: `Kafkad is a Rust implementation of the Kafka server side protocol handler. It allows people to accept 
                      inbound connections from Kafka clients and handle the requests. The implementation is sans-io, allowing 
                      it to have a massive versatility in tests and tunnelling capabilities.`,
        link: "https://github.com/rapidrecast/kafkad-rs"
      },
      {
        title: "Tazama",
        description: `Tazama is an advanced, multi-tenant Open Source financial crime management platform under the Linux 
                      Foundation. It provides robust fraud detection, and we are currently building investigation and case 
                      management tools while ensuring high levels of data protection, security, and auditability. LexTego 
                      led on the product and design. It was designed to support automated fraud detection at scale. Tazama’s 
                      infrastructure is tailored to handle massive transaction volumes with minimal latency, enabling efficient 
                      and secure fraud management solutions. Currently, we utilise ArangoDB in a TypeScript environment for our 
                      core components. We are exploring alternative solutions, with PostgreSQL emerging as a leading candidate 
                      to replace Arango, but we need to review our TypeScript components to improve volumes and latency. Our 
                      current system processes 2,700 payments per second (11,400 events) with an average latency of 100ms. To 
                      support growth and improve performance, we aim to scale this to 15,000 payments per second while achieving 
                      a reduced latency target of 35ms. We are particularly interested in leveraging Rust to improve database 
                      interactions, optimise system performance, and ensure low-latency, high-reliability operations. Rust’s 
                      speed and safety, combined with PostgreSQL's scalability, make this a promising direction for LexTego 
                      and the continued development of Tazama.`,
          link: "https://github.com/frmscoe"
      },
      {
        title: "Rust async GPU interface",
        description: `Yang Li and Maxwell Flitton have been building an async interface with Nvidia GPUs. This project 
        supports a bigger goal of streaming video data in a surgical operating room through machine learning models 
        to guide robots at King's College London. This is so robots can interpret visual information in real time during
        the surgery.`,
        link: ""
      },
      {
        title: "This Website!",
        description: `This website is built with a Rust backend that embeds a JavaScript React frontend into the Rust 
        binary. This means that the Rsut server also serves the frontend and the entire application is encased in a single 
        binary that can be deployed and run. The theory behind this project is covered in the third edition of the Packt 
        Rust and web programming book written by Maxwell Flitton. 
        Members can contribute to this project and have recieve guidance and tutoring from Maxwell Flitton on this project. 
        We plan to add more such as members sections, and the extra functionality will require SurrealDB integration.`,
        link: ""
      },
      {
        title: "Generating Rust code from JSON for FHIR schemas",
        description: `FHIR is a data standard for medical data to enable systems to talk to each other and process data 
        in a standard way. The FHIR schema is big, and manually building Rust structs would take too long. This project 
        aims to take the FHIR JSON schema and generate Rust structs so the FHIR schema is available to Rust programs. 
        We also aim to compile a dynamic C library from the project so other languages such as JavaScript and Python 
        can use the library and schemas.`,
        link: ""
      },
      {
        title: "Early-Stage Life Cycle Assessment and Reaction Scale-Up Using Large Language and Machine Learning Models in Rust",
        description: `Zak has developed a software on Rust using the Axum framework that integrates Life Cycle 
        Assessment (LCA)  and chemical scale-up in the early stages of product and process development to enhance 
        sustainability. The software addresses the challenges associated with transitioning chemical 
        reactions from laboratory to industrial scale, which requires extensive domain expertise. It facilitates 
        early-stage scale-up of lab-scale reactions and generates LCAs using Large Language Models (LLMs) and machine 
        learning. Designed for chemists, the tool helps bridge the communication gap with engineers and LCA 
        practitioners by leveraging the natural language capabilities of LLMs to transform lab reactions into 
        accessible and actionable insights. Through a user-friendly online platform, chemists can input lab-scale 
        reactions and novel chemicals to generate LCAs and scale-up reports, thus promoting informed decision-making 
        in sustainable product development.

        The software architecture was strategically chosen to be implemented in Rust, leveraging its Axum framework 
        to efficiently handle the high concurrency and intensive I/O operations inherent in the application. 
        The choice of Rust was advantageous due to its performance characteristics and safety guarantees, 
        which are crucial for the application which has too  process approximately 200 prompts per submission and 
        interface with 26 different machine learning models via ONNX Runtime. This setup results in 
        substantial I/O activity, making Axum's asynchronous capabilities ideal for managing multiple, 
        simultaneous I/O operations effectively.

        Rust's compile-time error checking and enforcement of strict type and memory safety significantly reduce 
        the risk of bugs that are common in large-scale applications, particularly those involving complex data 
        manipulations and concurrency. This robustness is essential for ensuring the reliability of the application 
        as it scales to accommodate potentially hundreds of users concurrently. The anticipated heavy user traffic 
        necessitates a system capable of high throughput and low latency, qualities that Rust and Axum deliver by 
        optimizing resource management and streamlining execution paths. The application's architecture, therefore, 
        not only supports the operational demands of large-scale chemical data processing but also enhances 
        maintainability and stability as user load increases.`,
        link: ""
      },
    ];
  
    return (
      <Styles.ProjectsContainer>
        {projectList.map((project, index) => (
          <Styles.ProjectCard key={index}>
            <Styles.ProjectTitle>{project.title}</Styles.ProjectTitle>
            <Styles.ProjectDescription>{project.description}</Styles.ProjectDescription>
            {project.link && (
              <Styles.ProjectButton href={project.link} target="_blank" rel="noopener noreferrer">
                View Project
              </Styles.ProjectButton>
            )}
          </Styles.ProjectCard>
        ))}
      </Styles.ProjectsContainer>
    );
  };
  